export enum PrivatePensionKind {
  PGBL = 1,
  VGBL = 2,
}

export type PrivatePensionBeneficiary = {
  name: string;
  relatedPartyId: number;
  birthDate: Date;
  participationPercentage: number;
};

export enum PrivatePensionPortabilityRentabilityType {
  /** Retratável */
  FixedReturnRate = 'fixedReturnRate',
  /** Irretratável */
  VariableReturnRate = 'variableReturnRate',
}

export enum PrivatePensionTaxSystem {
  Progressive = 1,
  Regressive = 2,
}

export enum PrivatePensionPortabilityTransferType {
  Total = 1,
  Partial = 2,
}

export type PrivatePensionPortabilityInfo = {
  certificateNumber: string;
  susepNumber: string;
  susepNumberAutofilled?: boolean;
  clientInsuranceCompany: number;
  clientInsuranceCompanyDocument: string;
  fundDocument: string;
  planName: string;
  rentabilityType: PrivatePensionPortabilityRentabilityType;
  rentabilityTypeAutofilled?: boolean;
  taxSystem: PrivatePensionTaxSystem;
  taxSystemAutofilled?: boolean;
  transferType: PrivatePensionPortabilityTransferType;
  value: number;
};

export enum PrivatePensionPaymentMethod {
  Debit = 1,
  /** Boleto Bancário */
  BankSlip = 2,
}

export type PrivatePensionAccountHolder = {
  name: string;
  email: string;
  cpf: string;
  bankAccountNumber: number;
  bankAccountDigit: number;
  bankAgencyNumber: number;
  bankAgencyDigit: number;
  bankId: number;
  relatedPartyId: number;
  birthDate: Date;
  paymentMethod: PrivatePensionPaymentMethod;
  manuallySet: boolean;
};
